import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import {
  Button, Checkbox, CircularProgress, styled, TextField,
} from "@material-ui/core";

function getModalStyle() {
  return {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    display: "block",
    "overflow-y": "auto",
    "max-height": "80%",
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: "400px !important",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: 25,
  },
  fieldset: {
    border: "none",
    display: "flex",
    gap: "1rem",
    margin: 0,
    padding: 0,
  },
}));

const ConfirmationModal = ({
  open, onClose, onCloseParent, callback, message,
}) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);

  return (
    <Modal open={open}>
      <div style={getModalStyle()} className={classes.paper}>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <div>
            <p className="simple-modal-description">{message}</p>
            <fieldset className={classes.fieldset}>
              <div
                className="buttonContainer"
                style={{ marginBottom: 0 }}
                onClick={
                  isLoading
                    ? null
                    : async () => {
                      setIsLoading(true);

                      await callback();
                      setIsLoading(false);
                      onClose();
                      if (onCloseParent) {
                        onCloseParent();
                      }
                    }
                }
              >
                Yes
              </div>
              <div className="buttonContainer" style={{ marginBottom: 0 }} onClick={onClose}>
                Cancel
              </div>
            </fieldset>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
